import { render } from "./ForEnterprises.vue?vue&type=template&id=17ec25f3"
import script from "./ForEnterprises.vue?vue&type=script&lang=js"
export * from "./ForEnterprises.vue?vue&type=script&lang=js"

import exportComponent from "/home/george/dev/git.avlos.io/infrastructure/pages/avlos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__